import { useFlag } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { useEffect, forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { redirectTo } from 'actions/core/navigation';
import { fetchWorkflowForNew } from 'actions/workflows';
import LoadingState from 'components/core/loading_state';
import { useProductRefreshAppShell } from 'features/app_shell/product_refresh/useProductRefreshAppShell';
import { setLocalStorageAlert } from 'hooks/use_local_storage_alerts';
import { useBooleanState } from 'hooks/useBooleanState';
import { useGetNewWorkflowPermissionsQuery } from 'services/workflows/api';
import { publisherWorkflowsT } from 'services/workflows/publisher_workflows_i18n';
import { getWorkflowsAppBasePath, parseParams } from 'services/workflows/url';
import { CreateYourOwn as CreateCustomWorkflowModal } from '../modals';
import { Header } from './header';
import { ListHeader, ListWrapper, ListTitleButton, ListTitleWrapper } from '../styles/layout';
import { TemplatesList } from '../templates_list';
const customListWrapperIsTabletUpCss = "cw6ii4k";
const customListWrapperCss = "c146imd8";
const CustomListWrapper = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <ListWrapper ref={ref} {...props} className={classNames(customListWrapperCss, {
    [customListWrapperIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const TemplateGallery = ({
  match,
  isManaged = false
}) => {
  const dispatch = useDispatch();
  const [popupIsOpen, openPopup, closePopup] = useBooleanState(false);
  const owner = isManaged ? {
    type: 'organization'
  } : parseParams(match).owner;
  const {
    type,
    id
  } = owner;
  const workflowsExtractionEnabled = useFlag('raven_workflows_extraction');
  const isWorkflowsAppShellRebrand = useProductRefreshAppShell();
  const {
    isFetching,
    isSuccess: hasNewPermissions,
    error
  } = useGetNewWorkflowPermissionsQuery({
    owner
  });
  useEffect(() => {
    if (hasNewPermissions) {
      dispatch(fetchWorkflowForNew({
        type,
        id
      }, workflowsExtractionEnabled, isWorkflowsAppShellRebrand));
    }
  }, [dispatch, type, id, isFetching, hasNewPermissions, workflowsExtractionEnabled, isWorkflowsAppShellRebrand]);
  if (!isFetching && !hasNewPermissions) {
    const errorMessage = error.type === 'policy' ? I18n.t('errors.policy.cannot_perform_this_action') : error.message;
    setLocalStorageAlert(errorMessage);
    dispatch(redirectTo(`${getWorkflowsAppBasePath(isWorkflowsAppShellRebrand)}/user/me`));
  }
  if (isFetching) {
    return <LoadingState />;
  }
  return hasNewPermissions && <>
      <Header owner={owner} />
      <CustomListWrapper>
        <ListHeader>
          <ListTitleWrapper>
            <BodyText size="large">
              {publisherWorkflowsT('publisher.workflows.workflow_templates.list_title', isWorkflowsAppShellRebrand)}
            </BodyText>
          </ListTitleWrapper>
          <ListTitleButton decoration="secondary-outline" size="small" onClick={openPopup}>
            {publisherWorkflowsT('publisher.workflows.workflow_templates.create_your_own', isWorkflowsAppShellRebrand)}
          </ListTitleButton>
        </ListHeader>
        <TemplatesList owner={owner} />
        <CreateCustomWorkflowModal owner={owner} isOpen={popupIsOpen} onClose={closePopup} />
      </CustomListWrapper>
    </>;
};

require("./template_gallery.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./template_gallery.js");